import React, { useEffect, useRef, useState, useContext} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonButtons, IonButton, IonMenuButton, IonModal, IonLabel, IonText, IonFooter, IonImg } from '@ionic/react';
import { IonGrid, IonRow, IonCol, IonInput } from '@ionic/react';


import '../../../css/layout.css';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { TakePhoto, photos } from './TakePhoto';

 export function ProfileSetting_ContactInfo (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID ] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    /*let currentFirstNameRef = useRef();
    let currentLastNameRef = useRef();
    let currentUsernameRef = useRef();
    let currentPasswordRef = useRef();
    let currentPhoneNumberRef = useRef();
    let currentEmailRef = useRef();
    let currentAddressRef = useRef();
    let currentCityRef = useRef();
    let currentCountryRef = useRef();*/

    let [currentFirstName, setCurrentFirstName] = useState(null);
    let [currentLastName, setCurrentLastName] = useState(null);
    let [currentUsername, setCurrentUsername] = useState(null);
    let [currentPassword, setCurrentPassword] = useState(null);
    let [currentPhoneNumber, setCurrentPhoneNumber] = useState(null);
    let [currentEmail, setCurrentEmail] = useState(null);
    let [currentAddressNumber, setCurrentAddressNumber] = useState(null);
    let [currentStreetName, setCurrentStreetName] = useState(null);
    let [currentCity, setCurrentCity] = useState(null);
    let [currentCityDistrict, setCurrentCityDistrict] = useState(null);
    let [currentCountryRegion, setCurrentCountryRegion] = useState(null);
    let [currentCountry, setCurrentCountry] = useState(null);
    let [currentDigitalAddress, setCurrentDigitalAddress] = useState(null);
    let [currentEmployeeAttachement, setCurrentEmployeeAttachement] = useState(null);
    let [selectedFile, setSelectedFile] = useState(null);

    let updateFirstNameRef = useRef();
    let updateLastNameRef = useRef();
    let updateUsernameRef = useRef();
    let updatePasswordRef = useRef();
    let updatePhoneNumberRef = useRef();
    let updateEmailRef = useRef();
    let updateAddressNumberRef = useRef();
    let updateStreetNameRef = useRef();
    let updateCityRef = useRef();
    let updateCityDistrictRef = useRef();
    let updateCountryRegionRef = useRef();
    let updateCountryRef = useRef();
    let updateDigitalAddressRef = useRef();

    let [companyRole, setCompanyRole] = useState(null);
    let [hireDate, setHireDate] = useState(null);
    let [hourlyPay, setHourlyPay] = useState(null);
    let [jobFunction, setJobFunction] = useState(null);

    let [currentFirstNameDisplay, setCurrentFirstNameDisplay] = useState('inline-block');
    let [currentLastNameDisplay, setCurrentLastNameDisplay] = useState('inline-block');
    let [currentUsernameDisplay, setCurrentUsernameDisplay] = useState('inline-block');
    let [currentPasswordDisplay, setCurrentPasswordDisplay] = useState('inline-block');
    let [currentPhoneNumberDisplay, setCurrentPhoneNumberDisplay] = useState('inline-block');
    let [currentEmailDisplay, setCurrentEmailDisplay] = useState('inline-block');
    let [currentAddressNumberDisplay, setCurrentAddressNumberDisplay] = useState('inline-block');
    let [currentStreetNameDisplay, setCurrentStreetNameDisplay] = useState('inline-block');
    let [currentCityDisplay, setCurrentCityDisplay] = useState('inline-block');
    let [currentCityDistrictDisplay, setCurrentCityDistrictDisplay] = useState('inline-block');
    let [currentCountryRegionDisplay, setCurrentCountryRegionDisplay] = useState('inline-block');
    let [currentCountryDisplay, setCurrentCountryDisplay] = useState('inline-block');
    let [currentDigitalAddressNumber, setCurrentDigitalAddressNumber] = useState('inline-block');

    let [updateFirstNameDisplay, setUpdateFirstNameDisplay]  = useState('none');
    let [updateLastNameDisplay, setUpdateLastNameDisplay] = useState('none');
    let [updateUsernameDisplay, setUpdateUsernameDisplay] = useState('none');
    let [updatePasswordDisplay, setUpdatePasswordDisplay] = useState('none');
    let [updatePhoneNumberDisplay, setUpdatePhoneNumberDisplay] = useState('none');
    let [updateEmailDisplay, setUpdateEmailDisplay] = useState('none');
    let [updateAddressNumberDisplay, setUpdateAddressNumberDisplay] = useState('none');
    let [updateStreetNameDisplay, setUpdateStreetNameDisplay] = useState('none');
    let [updateCityDisplay, setUpdateCityDisplay] = useState('none');
    let [updateCityDistrictDisplay, setUpdateCityDistrictDisplay] = useState('none');
    let [updateCountryRegionDisplay, setUpdateCountryRegionDisplay] = useState('none');
    let [updateCountryDisplay, setUpdateCountryDisplay] = useState('none');
    let [updateDigitalAddressNumber, setUpdateDigitalAddressNumber] = useState('none');


    let [updateEmployeeProfileDisplay, setUpdateEmployeeProfileDisplay] = useState('inline-block');
    let [submit_cancelEmployeeProfileDisplay, setSubmit_cancelEmployeeProfileDisplay] = useState('none');

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);

    useEffect(() => {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74800);
        formData.append('user', acctID);
        formData.append('xEmployeeID', employeeID);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
        }
        */
       
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '00_reetrieveProfile_employeeInfo',
                user: acctID,
                xEmployeeID: employeeID,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);
            
            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    /*setCompanyRole(cols[1]);
                    setCurrentFirstName(cols[2]);
                    setCurrentLastName(cols[3]);
                    setCurrentUsername(cols[4]);
                    setCurrentPassword(cols[5]);
                    setHireDate(cols[6]);
                    setHourlyPay(cols[7]);
                    setJobFunction(cols[8]);
                    setCurrentPhoneNumber(cols[9]);
                    setCurrentEmail(cols[10]);
                    setCurrentAddress(cols[11]);
                    setCurrentCity(cols[12]);
                    setCurrentCountry(cols[13]);*/

                    setCompanyRole(cols[1]);
                    setCurrentFirstName(cols[2]);
                    setCurrentLastName(cols[3]);
                    setCurrentUsername(cols[4]);
                    setCurrentPassword(cols[5]);
                    setHireDate(cols[6]);
                    setHourlyPay(cols[7]);
                    setJobFunction(cols[8]);
                    setCurrentPhoneNumber(cols[9]);
                    setCurrentEmail(cols[10]);
                    setCurrentAddressNumber(cols[11]);
                    setCurrentStreetName(cols[12]);
                    setCurrentCity(cols[13]);
                    setCurrentCityDistrict(cols[14]);
                    setCurrentCountryRegion(cols[15]);
                    setCurrentCountry(cols[16]);
                    setCurrentDigitalAddress(cols[17]);
                    setCurrentEmployeeAttachement(cols[18]);

                    setCurrentEmployeeAttachementHandler(cols[18]);

                }



        })

    }, [props.openModal]);

    function setCurrentEmployeeAttachementHandler(event) {  

        fetch(baseURL+event)
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let initialFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setSelectedFile(initialFile);
        })
    }

    function submit_updateEmployeeProfile()
    {

        let tracker = '';
        if(props.data.source == 'profile')
        {
         tracker = '00_updateEmployeeInformation';
        }
        if(props.data.source == 'profile')
        {
         tracker = '00_updateEmployeeInformation_password';
        }

        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xEmployeeID', employeeID);
        formData.append('xEmployeeFirstName', currentFirstName)
        formData.append('xEmployeeLastName', currentLastName);
        formData.append('xUpdateUsername', currentUsername);
        formData.append('xUpdatePassword', currentPassword);
        formData.append('xEmployeePhoneNumber', currentPhoneNumber);
        formData.append('xEmployeeEmailAddress', currentEmail);
        formData.append('xEmployeeAddressNumber', currentAddressNumber);
        formData.append('xEmployeeStreetName', currentStreetName);
        formData.append('xEmployeeCity', currentCity);
        formData.append('xEmployeeCityDistrict', currentCityDistrict);
        formData.append('xEmployeeCountryRegion', currentCountryRegion);
        formData.append('xEmployeeCountry', currentCountry);
        formData.append('xEmployeeDigitalAddressID', currentDigitalAddress);
        formData.append('xImageFile', selectedFile);
        formData.append('sessionID', sessionID);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
              
        /*const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '00_updateEmployeeInformation',
                user: acctID,
                xEmployeeID: employeeID,
                xEmployeeFirstName: currentFirstName,
                xEmployeeLastName: currentLastName,
                xUpdateUsername: currentUsername,
                xUpdatePassword: currentPassword,
                xEmployeePhoneNumber: currentPhoneNumber,
                xEmployeeEmailAddress: currentEmail,
                xEmployeeAddressNumber: currentAddressNumber,
                xEmployeeStreetName: currentStreetName,
                xEmployeeCity: currentCity,
                xEmployeeCityDistrict: currentCityDistrict,
                xEmployeeCountryRegion: currentCountryRegion,
                xEmployeeCountry: currentCountry,
                xEmployeeDigitalAddressID: currentDigitalAddress,
                xImageFile: currentEmployeeAttachement,
                sessionID: sessionID,

            }),
        }*/


        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);

            props.closeModal();
            // let rows = res.toString().split('~~~');
            // let rowLength = rows.length;

            //     for (let rownum = 0; rownum < rowLength - 1; ++rownum)
            //     {
            //         let cols = rows[rownum].split('|');

            //         setCompanyRole(cols[1]);
            //         setCurrentFirstName(cols[2]);
            //         setCurrentLastName(cols[3]);
            //         setCurrentUsername(cols[4]);
            //         setCurrentPassword(cols[5]);
            //         setHireDate(cols[6]);
            //         setHourlyPay(cols[7]);
            //         setJobFunction(cols[8]);
            //         setCurrentPhoneNumber(cols[9]);
            //         setCurrentEmail(cols[10]);
            //         setCurrentAddressNumber(cols[11]);
            //         setCurrentStreetName(cols[12]);
            //         setCurrentCity(cols[13]);
            //         setCurrentCityDistrict(cols[14]);
            //         setCurrentCountryRegion(cols[15]);
            //         setCurrentCountry(cols[16]);
            //         setCurrentDigitalAddress(cols[17]);
            //         setCurrentEmployeeAttachement(cols[18]);

            //     }
        })
    }


    function selectedFileHandler1(event)
    {
        //setProductImageNumber("1");
        setSelectedFile(event);
        setTakePhotoStatus1(false);
    }

    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        if(event.target.dataset.id == "1")
        {
            const file = event.target.files ? event.target.files[0] : null;
            //setProductImageNumber(event.target.dataset.id);
            setSelectedFile(file);
        }
    }
    //const xTracker = Tracker;
    //const xUsername = pUsername;
    //const xPassword = pPassword;

    //alert('In Profile Setting');
    //alert(updateEmployeeProfileDisplay);
    //alert(schema);

    return (

        <React.Fragment>
            
                        
        {props.openModal == true ?
        (
            <IonModal isOpen={ props.openModal }>
                <IonHeader style={{color: 'black'}}>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <h3>CONTACT INFO</h3>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonHeader>
                
                <IonContent className='grid_content'>
                    {props.data.source == 'profile' &&      
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel > First Name: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentFirstName}
                                        placeholder="Enter First Name"
                                        onIonChange={(e) => setCurrentFirstName(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>                        
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel> Last Name: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentLastName}
                                        placeholder="Enter Last Name"
                                        onIonChange={(e) => setCurrentLastName(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel> Username </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentUsername}
                                        placeholder="Enter Username"
                                        onIonChange={(e) => setCurrentUsername(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel> Password </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonText> {currentPassword} </IonText>
                                    </IonCol>
                                    {/*<IonCol size='12'>
                                        <IonInput 
                                        type='password' 
                                        className='professional-input'
                                        value={currentPassword}
                                        placeholder="Enter Password"
                                        onIonChange={(e) => setCurrentPassword(e.target.value)}
                                        ></IonInput>
                                    </IonCol>*/}
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel>MTN Momo Number: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput 
                                        className='professional-input'
                                        value={currentPhoneNumber}
                                        placeholder="Enter Momo Number"
                                        onIonChange={(e) => setCurrentPhoneNumber(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel> Email Address: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentEmail}
                                        placeholder="Enter Email"
                                        onIonChange={(e) => setCurrentEmail(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel >Address Number: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentAddressNumber}
                                        placeholder="Enter Address Number"
                                        onIonChange={(e) => setCurrentAddressNumber(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel >Street Name: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentStreetName}
                                        placeholder="Enter Street Name"
                                        onIonChange={(e) => setCurrentStreetName(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel >City: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentCity}
                                        placeholder="Enter City"
                                        onIonChange={(e) => setCurrentCity(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel> City District: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentCityDistrict}
                                        placeholder="Enter Last Name"
                                        onIonChange={(e) => setCurrentCityDistrict(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel> Country Region: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentCountryRegion}
                                        placeholder="Enter Current Country"
                                        onIonChange={(e) => setCurrentCountryRegion(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel> Country: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentCountry}
                                        placeholder="Enter Current Country"
                                        onIonChange={(e) => setCurrentCountry(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel >Digital Address: </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput className='professional-input'
                                        value={currentDigitalAddress}
                                        placeholder="Enter Digital Address"
                                        onIonChange={(e) => setCurrentDigitalAddress(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='12'> 
                                        <IonLabel>Employee Attachement</IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonImg src={currentEmployeeAttachement}></IonImg>
                                    </IonCol>
                                    <IonCol size='5'>
                                        <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                                        {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                                    </IonCol>
                                    <IonCol size='1'> 
                                        <IonLabel>OR</IonLabel>
                                    </IonCol>
                                    <IonCol size='5'>
                                        <input className='professional-input'
                                            type="file"
                                            accept="image/jpeg"
                                            data-id='1'
                                            onChange={handleFileChange}
                                        />
                                    </IonCol>
                                </IonRow>
                            </IonGrid>}
                        {props.data.source == 'password' && 
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel> update Password </IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput 
                                        type='password' 
                                        className='professional-input'
                                        value={currentPassword}
                                        placeholder="Enter Password"
                                        onIonChange={(e) => setCurrentPassword(e.target.value)}
                                        ></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>                        
                        }
                    </IonContent>
                    <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='6'>
                                    <IonButton style={{display: updateEmployeeProfileDisplay}} onClick={() => submit_updateEmployeeProfile()}>Save</IonButton>
                                </IonCol>
                                <IonCol size='6'>
                                    <IonButton style={{display: updateEmployeeProfileDisplay}} onClick={() => props.closeModal()}> Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonFooter>
                </IonModal>
           
        ) : null }
    </React.Fragment>

    );
};
